<template>
  <section
    id="flow"
    class="co-bg-striped px-5 py-20"
  >
    <div class="co-container-xs">
      <h2 class="co-heading-2-caption mb-6 text-center">
        <span class="co-display-11 block font-bold text-co-primary-400">簡単3ステップ</span>
        学習までの流れ
      </h2>
      <div class="mb-12 text-left text-co-gray-600 md:text-center">
        私たちのオンラインスクールでは、カウンセラーと相談しながら、<br class="hidden md:block">個々のニーズに合わせた学習プランを提供します。
      </div>
      <!-- Step1 -->
      <div class="mb-7 flex flex-row gap-3">
        <div class="te-flow-num pr-3 text-center font-bold leading-none">
          <span class="te-num-small co-display-13 block">Step</span>
          1
        </div>
        <div class="flex flex-col gap-3 sm:flex-row">
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Flow/flow-hearing.webp"
            width="180"
            height="120"
            alt="ヒアリング"
            class="mx-auto w-full sm:w-auto"
            loading="lazy"
          >
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              ヒアリング
            </h3>
            <div class="text-co-gray-600">
              まず無料相談にご参加ください。カウンセラーが目標や現状を丁寧にお伺いいたします。
            </div>
          </div>
        </div>
      </div>
      <!-- Step2 -->
      <div class="mb-7 flex flex-row gap-3">
        <div class="te-flow-num pr-3 text-center font-bold leading-none">
          <span class="te-num-small co-display-13 block">Step</span>
          2
        </div>
        <div class="flex flex-col gap-3 sm:flex-row">
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Flow/flow-plan.webp"
            width="180"
            height="120"
            alt="ご提案"
            class="mx-auto w-full sm:w-auto"
            loading="lazy"
          >
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              ご提案
            </h3>
            <div class="text-co-gray-600">
              後日、あなたに合わせた学習プランをご提案いたします。納得いただけるまで調整が可能です。
            </div>
          </div>
        </div>
      </div>
      <!-- Step3 -->
      <div class="flex flex-row gap-3">
        <div class="te-flow-num pr-3 text-center font-bold leading-none">
          <span class="te-num-small co-display-13 block">Step</span>
          3
        </div>
        <div class="flex flex-col gap-3 sm:flex-row">
          <img
            src="~/assets/images/Te/TeCourse/Ordermade/Flow/flow-entry.webp"
            width="180"
            height="120"
            alt="お申し込み"
            class="mx-auto w-full sm:w-auto"
            loading="lazy"
          >
          <div>
            <h3 class="co-display-10 mb-4 font-bold">
              お申し込み
            </h3>
            <div class="text-co-gray-600">
              決定した学習プランでお申し込みいただきます。さあ学習のスタートです！
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.te-flow-num {
  font-size: 3rem;
  color: #3CAAEB;
  border-right: 2px solid #46D7CB;
}
</style>
